module.exports = __webpack_public_path__ + "img/code.43fa43c3.png";